export const buildEltDocumentOpenLink = (
  partnerId: string,
  fYear: number,
  versionUID?: string | null
): string => {
  const documentUrl = `/page/jbp-elt-form/pid/${encodeURIComponent(partnerId)}/fYear/${fYear}`

  return versionUID ? `${documentUrl}/vid/${encodeURIComponent(versionUID)}` : documentUrl
}
